import { render, staticRenderFns } from "./horasprojetos.vue?vue&type=template&id=85b55b12&"
import script from "./horasprojetos.vue?vue&type=script&lang=js&"
export * from "./horasprojetos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports